















import { ActorTypes } from '@/data/models/actor.model';
import { Component, Vue } from 'vue-property-decorator';
import Attori from '../attori/Attori.vue';
import SelectAttore from '../attori/selectAttore/SelectAttore.vue';

@Component({
	components: {
		Attori,
		SelectAttore
	}
})
export default class PazientiList extends Vue{

	entity: string
	isComponentModalActive = false;
	redirectOnNew: string;

	constructor() {
		super();
		this.entity = ActorTypes.PATIENT;
		this.redirectOnNew = '/attori/*/edit?tab=3';
	}

	onNewClicked() {
		this.isComponentModalActive = true;
	}

}
